import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/[symbol]/page.tsx");
